<template>
  <div class="reduce-aigc-page">
    <!-- 左侧配置面板 -->
    <div class="editor-panel">
      <div class="panel-header">
        <div class="panel-title">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="panel-icon">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
          </svg>
          <span>模式选择</span>
        </div>
        <button class="btn-history" @click="showHistoryDialog = true">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          历史数据
        </button>
      </div>

      <div class="config-panel">
        <!-- 顶部提示文字 -->
        <div class="top-hint">
          <p>bro，我知道你的论文都是 AI 生成的,<br/>但没关系，因为你找到了  ↓</p>
        </div>

        <!-- 模式选择卡片 -->
        <div class="mode-cards">
          <div class="mode-card" :class="{ active: mode === 'reduce' }" @click="mode = 'reduce'">
            <div class="card-icon" style="background: #e0f2fe; color: #0284c7;">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="24" height="24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
              </svg>
            </div>
            <div class="card-content">
              <h3>降重复率</h3>
              <p>深度改写降低重复率，保持原意的同时优化表达方式，可能增加aigc率</p>
            </div>
            <div class="check-icon" v-if="mode === 'reduce'">
              <svg fill="currentColor" viewBox="0 0 20 20" width="20" height="20">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
              </svg>
            </div>
          </div>

          <div class="mode-card" :class="{ active: mode === 'aigc' }" @click="mode = 'aigc'">
            <div class="card-icon" style="background: #ede9fe; color: #7c3aed;">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="24" height="24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"/>
              </svg>
            </div>
            <div class="card-content">
              <h3>降AIGC率</h3>
              <p>去除AI生成痕迹，使文本更自然流畅，不影响原有重复率</p>
            </div>
            <div class="check-icon" v-if="mode === 'aigc'">
              <svg fill="currentColor" viewBox="0 0 20 20" width="20" height="20">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
              </svg>
            </div>
          </div>

          <div class="mode-card" :class="{ active: mode === 'both' }" @click="mode = 'both'">
            <div class="card-icon" style="background: #dcfce7; color: #16a34a;">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="24" height="24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
              </svg>
            </div>
            <div class="card-content">
              <h3>降重+降AIGC</h3>
              <p>同时降低重复率与AI痕迹，一次处理双重优化，消耗双倍积分</p>
            </div>
            <div class="check-icon" v-if="mode === 'both'">
              <svg fill="currentColor" viewBox="0 0 20 20" width="20" height="20">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
              </svg>
            </div>
          </div>

          <div class="mode-card" :class="{ active: mode === 'academic' }" @click="mode = 'academic'">
            <div class="card-icon" style="background: #ffedd5; color: #ea580c;">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="24" height="24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/>
              </svg>
            </div>
            <div class="card-content">
              <h3>学术润色</h3>
              <p>提升学术表达规范，优化专业术语，增强文本学术性，可能增加aigc率</p>
            </div>
            <div class="check-icon" v-if="mode === 'academic'">
              <svg fill="currentColor" viewBox="0 0 20 20" width="20" height="20">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
              </svg>
            </div>
          </div>
        </div>

        <!-- 使用提示 -->
        <div class="tips-section">
          <div class="tip-card">
            <div class="tip-content">
              <h4>使用说明</h4>
              <ul>
                <li>每300字消耗{{ pointsConfig.reduceAigc }}积分，不足300字按300字计算</li>
                <li>建议分段处理，每次输入文本不超过1000字，效果更佳</li>
                <li>AI会智能改写表达方式，同时保持原文核心意思不变</li>
                <li>长文本请分多次处理，逐段优化可获得更好的降重效果</li>
                <li class="privacy-tip">我们不会保存您的学术文档，不用担心泄露，文档仅保留3天，请尽快下载</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 右侧预览区 -->
    <div class="preview-panel">
      <div class="tabs">
        <button :class="['tab', activeTab === 'text' ? 'active' : '']" @click="activeTab = 'text'">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
          粘贴文本处理
        </button>
        <button :class="['tab', activeTab === 'file' ? 'active' : '']" @click="activeTab = 'file'">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
          </svg>
          上传文件处理
        </button>
      </div>

      <!-- 文档处理结果标题栏（固定在tabs下方） -->
      <div v-if="activeTab === 'file' && docId && originalParagraphs.length > 0" class="result-header-fixed">
        <div class="header-left">
          <!-- 返回按钮 -->
          <el-button
            type="text"
            icon="el-icon-back"
            @click="handleBackToUpload"
            class="back-btn"
          >
            返回
          </el-button>
          <!-- 分割线 -->
          <div class="divider"></div>
          <div class="header-info-group">
            <!-- 文件名 -->
            <div class="file-name-info">
              <!-- 处理模式标签 -->
              <span class="mode-tag" :class="'mode-' + docSelectedMode">{{ getModeLabel(docSelectedMode) }}</span>
              <i class="el-icon-document"></i>
              <span class="file-name">{{ docFileName }}</span>
            </div>
            <div class="stats-row">
              <!-- 处理字数 -->
              <div class="word-count-info">
                <span class="label">{{ parseStatus === 'parsed' ? '待处理字数' : '处理字数' }}：</span>
                <span class="count">{{ parseStatus === 'parsed' ? activeWordCount : fileWordCount }}</span>
                <span class="unit">字</span>
              </div>
              <!-- 消耗积分 -->
              <div class="points-info">
                <span class="label">消耗积分：</span>
                <span class="count">{{ parseStatus === 'parsed' ? actualPoints : calculateFilePoints() }}</span>
                <span class="unit">分</span>
              </div>
              <!-- 进度条（在消耗积分右边） -->
              <div v-show="parseStatus !== 'none'" class="progress-bar-container">
                <el-progress
                  :percentage="processProgress"
                  :stroke-width="8"
                  :color="progressColor"
                ></el-progress>
              </div>
            </div>
          </div>
        </div>
        <div class="header-actions">
          <el-button
            v-if="parseStatus === 'parsed'"
            size="medium"
            @click="handleProcessSelectedParagraphs"
            :disabled="!canStartProcess || loading"
            :loading="loading"
            class="custom-primary-btn"
          >
            <i class="el-icon-s-promotion"></i> {{ loading ? '处理中...' : '开始处理' }}
          </el-button>
          <el-button
            v-if="parseStatus === 'completed'"
            type="primary"
            size="medium"
            @click="handleExportDoc"
          >
            <i class="el-icon-download"></i> 导出Word
          </el-button>
        </div>
      </div>

      <div class="preview-content">
        <!-- 上传文件处理 -->
        <div v-show="activeTab === 'file'" class="file-upload-container">
          <!-- 上传区域 -->
          <div v-if="!docId" class="file-upload-area">
            <el-upload
              class="upload-demo"
              drag
              action="#"
              :auto-upload="false"
              :before-upload="beforeFileUpload"
              :on-change="handleFileChange"
              :disabled="loading"
              accept=".docx"
              :show-file-list="false"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip">仅支持DOCX格式的文件，DOC文件请先在Word中转换为DOCX（"另存为"-"Word文档(.docx)"），直接修改后缀名无效。</div>
            </el-upload>

            <!-- 文件信息 -->
            <div v-if="uploadedFile" class="file-info">
              <div class="file-details">
                <div class="file-name">
                  <i class="el-icon-document"></i>
                  <span>{{ uploadedFile.name }}</span>
                  <span class="file-size">({{ formatFileSize(uploadedFile.size) }})</span>
                </div>
              </div>
              <el-button
                v-if="parseStatus === 'none'"
                size="medium"
                :loading="loading"
                @click="handleParseDocument"
                class="custom-primary-btn process-btn"
              >
                {{ loading ? '解析中...' : '开始解析文档' }}
              </el-button>
            </div>
          </div>

          <!-- 文档处理结果展示 -->
          <div v-if="docId && originalParagraphs.length > 0" class="doc-process-result">
            <div class="doc-vertical-view">
              <!-- 工具栏：包含 Tab 切换和全选/反选按钮 -->
              <div class="selection-toolbar">
                <!-- Tab 切换 -->
                <div class="view-tabs">
                  <button
                    :class="['tab-btn', { active: paragraphViewMode === 'all' }]"
                    @click="paragraphViewMode = 'all'"
                  >
                    <i class="el-icon-document"></i>
                    查看全部 ({{ originalParagraphs.length }})
                  </button>
                  <button
                    :class="['tab-btn', { active: paragraphViewMode === 'selected' }]"
                    @click="paragraphViewMode = 'selected'"
                  >
                    <i class="el-icon-check"></i>
                    已选择 ({{ activeParagraphsCount }})
                  </button>
                </div>

                <!-- 全选/反选按钮（仅在解析状态显示） -->
                <div v-if="parseStatus === 'parsed'" class="selection-actions">
                  <el-button
                    size="small"
                    @click="selectAllParagraphs"
                    icon="el-icon-check"
                    class="btn-select-all"
                  >
                    全选
                  </el-button>
                  <el-button
                    size="small"
                    @click="invertSelection"
                    icon="el-icon-refresh"
                    class="btn-invert"
                  >
                    反选
                  </el-button>
                </div>
              </div>

              <!-- 段落列表：上下展示 -->
              <div class="paragraphs-vertical-list">
                <div
                  v-for="para in filteredParagraphs"
                  :key="'para-' + para.index"
                  class="paragraph-pair"
                  :class="{ active: processingIndex === para.index }"
                >
                  <!-- 原始段落 -->
                  <div class="para-section original" :class="{ deleted: para.deleted }">
                    <div class="para-header">
                      <!-- 复选框 -->
                      <el-checkbox
                        v-if="parseStatus === 'parsed'"
                        v-model="para.selected"
                        @change="handleCheckboxChange(para.index)"
                        class="para-checkbox"
                      ></el-checkbox>
                      <span class="para-label">原文</span>
                      <span class="para-index">段落 {{ para.index + 1 }}</span>
                      <span class="para-words-inline">({{ para.wordCount }}字)</span>
                    </div>
                    <div class="para-content" :class="{ 'deleted-content': para.deleted }">
                      {{ para.originalContent }}
                    </div>
                    <div v-if="para.deleted" class="deleted-tip">
                      <i class="el-icon-warning"></i> 此段落未选中，不会被处理
                    </div>
                  </div>

                  <!-- 处理后段落（只在未删除时显示） -->
                  <div v-if="!para.deleted" class="para-section processed">
                    <div class="para-header">
                      <span class="para-label">优化后</span>
                      <span class="para-index">段落 {{ para.index + 1 }}</span>

                      <!-- 对比按钮 -->
                      <el-button
                        v-if="processedParagraphs[para.index] && processedParagraphs[para.index].content && !processedParagraphs[para.index].processing"
                        type="text"
                        size="mini"
                        @click="toggleCompare(para.index)"
                        style="margin-right: 8px;"
                      >
                        <i :class="processedParagraphs[para.index].showCompare ? 'el-icon-close' : 'el-icon-s-operation'"></i>
                        {{ processedParagraphs[para.index].showCompare ? '关闭对比' : '对比' }}
                      </el-button>

                      <!-- 重新生成按钮（不在处理中时显示） -->
                      <el-button
                        v-if="processedParagraphs[para.index] && processedParagraphs[para.index].content && !processedParagraphs[para.index].processing"
                        type="text"
                        size="mini"
                        @click="regenerateParagraph(para.index)"
                      >
                        <i class="el-icon-refresh"></i> 重新生成
                      </el-button>

                      <!-- 处理中提示 -->
                      <span v-if="processedParagraphs[para.index] && processedParagraphs[para.index].processing" class="processing-tag">
                        <i class="el-icon-loading"></i> 重新生成中...
                      </span>
                    </div>

                    <!-- 内容区域 -->
                    <div class="para-content" :class="{ 'empty': !processedParagraphs[para.index] || (!processedParagraphs[para.index].content && !processedParagraphs[para.index].processing) }">
                      <template v-if="processedParagraphs[para.index] && processedParagraphs[para.index].processing">
                        <i class="el-icon-loading"></i> 正在生成...
                      </template>
                      <template v-else-if="processedParagraphs[para.index] && processedParagraphs[para.index].content">
                        {{ processedParagraphs[para.index].content }}
                      </template>
                      <template v-else>
                        等待处理...
                      </template>
                    </div>
                  </div>

                  <!-- 对比视图（只在未删除时显示） -->
                  <div
                    v-if="!para.deleted && processedParagraphs[para.index] && processedParagraphs[para.index].showCompare && processedParagraphs[para.index].content"
                    class="para-section compare"
                  >
                    <div class="para-header">
                      <span class="para-label">对比视图</span>
                      <div class="compare-legend">
                        <span class="legend-item">
                          <span class="legend-color deleted"></span>
                          <span>删除</span>
                        </span>
                        <span class="legend-item">
                          <span class="legend-color added"></span>
                          <span>新增</span>
                        </span>
                      </div>
                    </div>
                    <div class="para-content compare-content" v-html="getComparedText(para.index)"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 粘贴文本处理 -->
        <div v-show="activeTab === 'text'" class="text-areas">
          <!-- 第一组：左右布局容器 -->
          <div class="text-areas-horizontal">
            <!-- 输入区域 -->
            <div class="input-section">
              <div class="section-header">
                <h3>原始文本</h3>
                <div class="header-actions">
                  <span class="char-count">
                    共 {{ inputText.length }} 字 | 消耗 {{ calculatePoints() }} 积分<span v-if="mode === 'both'" style="color: #ef4444; font-weight: 600;"> x 2</span>
                  </span>
                </div>
              </div>
              <el-input
                type="textarea"
                v-model="inputText"
                placeholder="请粘贴需要处理的文本内容，建议每次不超过1000字..."
                :rows="10"
                maxlength="1000"
                show-word-limit
                class="fixed-height-textarea"
              ></el-input>
              <!-- 左侧按钮：一键生成 和 清空 -->
              <div class="left-actions">
                <el-button
                  type="primary"
                  size="medium"
                  :loading="loading"
                  :disabled="!inputText.trim()"
                  @click="handleReduce"
                  class="reduce-btn"
                >
                  <i v-if="!loading" class="el-icon-magic-stick"></i>
                  {{ loading ? '生成中...' : '一键生成' }}
                </el-button>
                <el-button
                  size="medium"
                  @click="handleClear"
                  :disabled="loading"
                  class="clear-btn"
                >
                  <i class="el-icon-delete"></i> 清空
                </el-button>
              </div>
            </div>

            <!-- 输出区域 -->
            <div class="output-section">
              <div class="section-header">
                <h3>优化结果</h3>
                <div class="header-actions">
                  <span v-if="outputText" class="char-count">{{ outputText.length }} 字</span>
                </div>
              </div>
              <el-input
                type="textarea"
                v-model="outputText"
                placeholder="优化后的文本将显示在这里..."
                :rows="10"
                readonly
                class="fixed-height-textarea"
                style="white-space: pre-wrap;"
              ></el-input>
              <!-- 右侧按钮：对比 和 复制 -->
              <div class="right-actions">
                <el-button
                  v-if="outputText"
                  type="success"
                  size="medium"
                  @click="handleCompare"
                  class="compare-btn"
                >
                  <i class="el-icon-s-operation"></i> 对比
                </el-button>
                <el-button
                  v-if="outputText"
                  type="primary"
                  size="medium"
                  @click="handleCopy"
                  class="copy-btn"
                >
                  <i class="el-icon-document-copy"></i> 复制
                </el-button>
              </div>
            </div>
          </div>

          <!-- 对比视图 -->
          <div v-if="showCompare && outputText" class="compare-view">
            <div class="compare-header">
              <h3>文本对比</h3>
              <el-button
                type="text"
                size="small"
                @click="showCompare = false"
                class="close-compare-btn"
              >
                <i class="el-icon-close"></i> 关闭对比
              </el-button>
            </div>
            <div class="compare-content-wrapper">
              <div class="compare-text" v-html="comparedText"></div>
            </div>
          </div>

          <!-- 分割线 -->
          <div class="text-divider"></div>

          <!-- 第二组：左右布局容器 -->
          <div class="text-areas-horizontal">
            <!-- 输入区域 -->
            <div class="input-section">
              <div class="section-header">
                <h3>原始文本</h3>
                <div class="header-actions">
                  <span class="char-count">
                    共 {{ inputText2.length }} 字 | 消耗 {{ calculatePoints2() }} 积分<span v-if="mode === 'both'" style="color: #ef4444; font-weight: 600;"> x 2</span>
                  </span>
                </div>
              </div>
              <el-input
                type="textarea"
                v-model="inputText2"
                placeholder="请粘贴需要处理的文本内容，建议每次不超过1000字..."
                :rows="10"
                maxlength="1000"
                show-word-limit
                class="fixed-height-textarea"
              ></el-input>
              <!-- 左侧按钮：一键生成 和 清空 -->
              <div class="left-actions">
                <el-button
                  type="primary"
                  size="medium"
                  :loading="loading2"
                  :disabled="!inputText2.trim()"
                  @click="handleReduce2"
                  class="reduce-btn"
                >
                  <i v-if="!loading2" class="el-icon-magic-stick"></i>
                  {{ loading2 ? '生成中...' : '一键生成' }}
                </el-button>
                <el-button
                  size="medium"
                  @click="handleClear2"
                  :disabled="loading2"
                  class="clear-btn"
                >
                  <i class="el-icon-delete"></i> 清空
                </el-button>
              </div>
            </div>

            <!-- 输出区域 -->
            <div class="output-section">
              <div class="section-header">
                <h3>优化结果</h3>
                <div class="header-actions">
                  <span v-if="outputText2" class="char-count">{{ outputText2.length }} 字</span>
                </div>
              </div>
              <el-input
                type="textarea"
                v-model="outputText2"
                placeholder="优化后的文本将显示在这里..."
                :rows="10"
                readonly
                class="fixed-height-textarea"
                style="white-space: pre-wrap;"
              ></el-input>
              <!-- 右侧按钮：对比 和 复制 -->
              <div class="right-actions">
                <el-button
                  v-if="outputText2"
                  type="success"
                  size="medium"
                  @click="handleCompare2"
                  class="compare-btn"
                >
                  <i class="el-icon-s-operation"></i> 对比
                </el-button>
                <el-button
                  v-if="outputText2"
                  type="primary"
                  size="medium"
                  @click="handleCopy2"
                  class="copy-btn"
                >
                  <i class="el-icon-document-copy"></i> 复制
                </el-button>
              </div>
            </div>
          </div>

          <!-- 对比视图 2 -->
          <div v-if="showCompare2 && outputText2" class="compare-view">
            <div class="compare-header">
              <h3>文本对比</h3>
              <el-button
                type="text"
                size="small"
                @click="showCompare2 = false"
                class="close-compare-btn"
              >
                <i class="el-icon-close"></i> 关闭对比
              </el-button>
            </div>
            <div class="compare-content-wrapper">
              <div class="compare-text" v-html="comparedText2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 历史数据对话框 -->
    <el-dialog
      title="历史数据"
      :visible.sync="showHistoryDialog"
      width="70%"
      :close-on-click-modal="false"
      custom-class="history-dialog"
    >
      <div class="history-content">
        <!-- Tab切换 -->
        <el-tabs v-model="historyActiveTab" type="card">
          <!-- 粘贴文本处理历史 -->
          <el-tab-pane label="粘贴文本处理" name="text">
            <div v-if="textHistory.length === 0" class="empty-history">
              <i class="el-icon-document"></i>
              <p>暂无历史记录</p>
            </div>
            <div v-else>
              <!-- 表格展示 -->
              <el-table
                :data="paginatedTextHistory"
                style="width: 100%"
                stripe
                :header-cell-style="{ background: '#f9fafb', color: '#374151', fontWeight: '600' }"
              >
                <el-table-column
                  prop="timestamp"
                  label="时间"
                  width="160"
                >
                </el-table-column>

                <el-table-column
                  label="模式"
                  width="130"
                >
                  <template slot-scope="scope">
                    <el-tag :type="getModeTagType(scope.row.mode)" size="small">
                      {{ getModeLabel(scope.row.mode) }}
                    </el-tag>
                  </template>
                </el-table-column>

                <el-table-column
                  label="文字内容"
                  min-width="200"
                >
                  <template slot-scope="scope">
                    <div class="table-text-preview">
                      {{ scope.row.inputText.substring(0, 50) }}{{ scope.row.inputText.length > 50 ? '...' : '' }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="inputLength"
                  label="字数"
                  width="100"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span class="table-word-count">{{ scope.row.inputLength }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="points"
                  label="消耗积分"
                  width="100"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span class="table-points">{{ scope.row.points }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  label="操作"
                  width="200"
                  align="center"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="viewTextDetail(scope.row)"
                    >
                      <i class="el-icon-view"></i> 查看
                    </el-button>
                    <el-button
                      type="text"
                      size="small"
                      @click="loadTextHistory(scope.row)"
                    >
                      <i class="el-icon-upload2"></i> 加载
                    </el-button>
                    <el-button
                      type="text"
                      size="small"
                      style="color: #f56c6c;"
                      @click="deleteTextHistory((textCurrentPage - 1) * textPageSize + scope.$index)"
                    >
                      <i class="el-icon-delete"></i> 删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>

              <!-- 分页 -->
              <div class="history-pagination">
                <el-pagination
                  @current-change="handleTextPageChange"
                  :current-page="textCurrentPage"
                  :page-size="textPageSize"
                  layout="total, prev, pager, next, jumper"
                  :total="textHistory.length"
                  small
                >
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>

          <!-- 上传文件处理历史 -->
          <el-tab-pane label="上传文件处理" name="file">
            <div v-if="fileHistory.length === 0" class="empty-history">
              <i class="el-icon-folder-opened"></i>
              <p>暂无历史记录</p>
            </div>
            <div v-else>
              <div class="history-list">
                <div
                  v-for="(item, index) in paginatedFileHistory"
                  :key="index"
                  class="history-item"
                >
                  <div class="history-item-header">
                    <div class="history-item-info">
                      <span class="history-time">{{ item.timestamp }}</span>
                      <el-tag :type="getModeTagType(item.mode)" size="mini">{{ getModeLabel(item.mode) }}</el-tag>
                      <span class="history-filename">{{ item.fileName }}</span>
                      <span class="history-words">{{ item.wordCount }} 字</span>
                      <span class="history-points">消耗 {{ item.points }} 积分</span>
                    </div>
                    <div class="history-item-actions">
                      <el-button
                        v-if="item.docId && item.progress === 100"
                        type="success"
                        size="mini"
                        @click="downloadHistoryDoc(item)"
                      >
                        <i class="el-icon-download"></i> 下载
                      </el-button>
                      <el-button
                        v-if="!isHistoryExpired(item.timestamp)"
                        type="primary"
                        size="mini"
                        @click="loadFileHistory(item)"
                        :disabled="!item.originalParagraphs || !item.processedParagraphs"
                      >
                        <i class="el-icon-upload2"></i> 加载
                      </el-button>
                      <el-tag
                        v-if="isHistoryExpired(item.timestamp)"
                        type="info"
                        size="mini"
                      >
                        已过期
                      </el-tag>
                      <el-button
                        type="danger"
                        size="mini"
                        icon="el-icon-delete"
                        @click="deleteFileHistory((fileCurrentPage - 1) * filePageSize + index)"
                      >
                      </el-button>
                    </div>
                  </div>
                  <div class="history-item-progress">
                    <span class="progress-label">处理进度：</span>
                    <el-progress
                      :percentage="item.progress"
                      :stroke-width="8"
                      :color="item.progress === 100 ? '#67c23a' : '#409eff'"
                    ></el-progress>
                  </div>
                  <div class="history-file-stats">
                    <span class="stat-item">
                      <i class="el-icon-document"></i>
                      共 {{ item.paragraphsCount }} 个段落
                    </span>
                    <span class="stat-item">
                      <i class="el-icon-check"></i>
                      已处理 {{ item.processedCount }} 个
                    </span>
                    <span v-if="!item.originalParagraphs || !item.processedParagraphs" class="stat-warning">
                      <i class="el-icon-warning"></i>
                      数据不完整，无法加载
                    </span>
                    <span v-if="isHistoryExpired(item.timestamp)" class="stat-warning">
                      <i class="el-icon-time"></i>
                      已超过3天，无法加载
                    </span>
                  </div>
                </div>
              </div>

              <!-- 分页 -->
              <div class="history-pagination">
                <el-pagination
                  @current-change="handleFilePageChange"
                  :current-page="fileCurrentPage"
                  :page-size="filePageSize"
                  layout="total, prev, pager, next, jumper"
                  :total="fileHistory.length"
                  small
                >
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>

    <!-- 文本详情查看对话框 -->
    <el-dialog
      title="文本详情"
      :visible.sync="showDetailDialog"
      width="80%"
      :close-on-click-modal="false"
      custom-class="detail-dialog"
      top="5vh"
    >
      <div v-if="currentDetailItem" class="detail-content">
        <!-- 详情头部信息 -->
        <div class="detail-header">
          <div class="detail-info-row">
            <span class="detail-label">处理时间：</span>
            <span class="detail-value">{{ currentDetailItem.timestamp }}</span>
            <el-tag :type="getModeTagType(currentDetailItem.mode)" size="small" style="margin-left: 12px;">
              {{ getModeLabel(currentDetailItem.mode) }}
            </el-tag>
          </div>
          <div class="detail-info-row">
            <span class="detail-label">字数统计：</span>
            <span class="detail-value">原文 {{ currentDetailItem.inputLength }} 字 → 优化后 {{ currentDetailItem.outputLength }} 字</span>
            <span class="detail-label" style="margin-left: 20px;">消耗积分：</span>
            <span class="detail-value" style="color: #f59e0b; font-weight: 600;">{{ currentDetailItem.points }} 分</span>
          </div>
        </div>

        <!-- 切换按钮 -->
        <div class="detail-tabs">
          <el-button
            :type="!detailShowCompare ? 'primary' : ''"
            size="small"
            @click="detailShowCompare = false"
          >
            <i class="el-icon-document"></i> 分开查看
          </el-button>
          <el-button
            :type="detailShowCompare ? 'primary' : ''"
            size="small"
            @click="detailShowCompare = true"
          >
            <i class="el-icon-s-operation"></i> 对比查看
          </el-button>
        </div>

        <!-- 分开查看 -->
        <div v-if="!detailShowCompare" class="detail-separate-view">
          <div class="detail-text-section">
            <div class="detail-section-header">
              <h4>原文</h4>
              <el-button
                type="text"
                size="small"
                @click="copyDetailText(currentDetailItem.inputText)"
              >
                <i class="el-icon-document-copy"></i> 复制
              </el-button>
            </div>
            <div class="detail-text-content">{{ currentDetailItem.inputText }}</div>
          </div>

          <div class="detail-text-section">
            <div class="detail-section-header">
              <h4>优化后</h4>
              <el-button
                type="text"
                size="small"
                @click="copyDetailText(currentDetailItem.outputText)"
              >
                <i class="el-icon-document-copy"></i> 复制
              </el-button>
            </div>
            <div class="detail-text-content">{{ currentDetailItem.outputText }}</div>
          </div>
        </div>

        <!-- 对比查看 -->
        <div v-else class="detail-compare-view">
          <div class="detail-section-header">
            <h4>对比视图</h4>
            <div class="compare-legend">
              <span class="legend-item">
                <span class="legend-color deleted"></span>
                <span>删除</span>
              </span>
              <span class="legend-item">
                <span class="legend-color added"></span>
                <span>新增</span>
              </span>
            </div>
          </div>
          <div class="detail-compare-content" v-html="detailComparedText"></div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showDetailDialog = false">关闭</el-button>
        <el-button type="primary" @click="loadTextHistory(currentDetailItem)">
          <i class="el-icon-upload2"></i> 加载到编辑器
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as Diff from 'diff'
import { baseURL } from '@/utils/request'
import { encrypt } from '@/utils/crypto'

export default {
  name: 'ReduceAigc',
  data() {
    return {
      loading: false,
      showCompare: false,
      activeTab: 'text',
      uploadedFile: null,
      fileOutputText: '',
      fileWordCount: 0,
      pointsConfig: {
        reduceAigc: 1
      },
      baseURL: baseURL,
      // 第二组数据的 loading 和 showCompare（不需要存储）
      loading2: false,
      showCompare2: false,
      // 文档处理相关
      docId: null,
      docFileName: '',
      docSelectedMode: '', // 保存解析文档时选择的模式
      originalParagraphs: [],
      processedParagraphs: [],
      processingIndex: -1,
      showDocCompare: false,
      isFromHistory: false,  // 标记是否从历史记录加载
      // 新增：解析状态
      parseStatus: 'none', // none: 未解析, parsing: 解析中, parsed: 已解析, processing: 处理中, completed: 已完成
      // 历史记录相关
      showHistoryDialog: false,
      historyActiveTab: 'text',
      textHistory: [],
      fileHistory: [],
      // 分页相关
      textCurrentPage: 1,
      textPageSize: 5,
      fileCurrentPage: 1,
      filePageSize: 5,
      // 查看详情相关
      showDetailDialog: false,
      currentDetailItem: null,
      detailShowCompare: false,
      // 段落视图模式
      paragraphViewMode: 'all', // 'all': 查看全部, 'selected': 查看已选择
      // 实际消耗积分（用于文件处理）
      actualPoints: 0
    }
  },
  computed: {
    mode: {
      get() {
        return this.$store.state.reduceAigc.mode
      },
      set(value) {
        this.$store.commit('setReduceAigcMode', value)
      }
    },
    inputText: {
      get() {
        return this.$store.state.reduceAigc.inputText
      },
      set(value) {
        this.$store.commit('setReduceAigcInputText', value)
      }
    },
    outputText: {
      get() {
        return this.$store.state.reduceAigc.outputText
      },
      set(value) {
        this.$store.commit('setReduceAigcOutputText', value)
      }
    },
    inputText2: {
      get() {
        return this.$store.state.reduceAigc.inputText2
      },
      set(value) {
        this.$store.commit('setReduceAigcInputText2', value)
      }
    },
    outputText2: {
      get() {
        return this.$store.state.reduceAigc.outputText2
      },
      set(value) {
        this.$store.commit('setReduceAigcOutputText2', value)
      }
    },
    // 计算已处理的段落数
    processedCount() {
      if (!this.processedParagraphs || this.processedParagraphs.length === 0) {
        return 0
      }
      return this.processedParagraphs.filter(p => p && p.content && p.content.trim() !== '').length
    },
    // 计算处理进度百分比
    processProgress() {
      if (!this.originalParagraphs || this.originalParagraphs.length === 0) {
        return 0
      }
      // 使用未删除的段落数来计算进度
      const activeCount = this.activeParagraphsCount
      if (activeCount === 0) {
        return 0
      }
      return Math.round((this.processedCount / activeCount) * 100)
    },
    // 进度条颜色
    progressColor() {
      if (this.processProgress === 100) {
        return '#67c23a' // 绿色
      }
      return '#7275f2' // 紫色
    },
    // 新增：未删除的段落数
    activeParagraphsCount() {
      return this.originalParagraphs.filter(p => !p.deleted).length
    },
    // 新增：未删除段落的总字数
    activeWordCount() {
      return this.originalParagraphs
        .filter(p => !p.deleted)
        .reduce((sum, p) => sum + p.wordCount, 0)
    },
    // 新增：是否可以开始处理
    canStartProcess() {
      return this.parseStatus === 'parsed' && this.activeParagraphsCount > 0
    },
    // 新增：根据视图模式过滤段落
    filteredParagraphs() {
      if (this.paragraphViewMode === 'selected') {
        // 只显示已选择的段落（未删除的）
        return this.originalParagraphs.filter(p => !p.deleted)
      }
      // 显示全部段落
      return this.originalParagraphs
    },
    // 详情对比文本
    detailComparedText() {
      if (!this.currentDetailItem || !this.currentDetailItem.inputText || !this.currentDetailItem.outputText) {
        return ''
      }
      return this.generateComparedHTML(this.currentDetailItem.inputText, this.currentDetailItem.outputText)
    },
    // 文本历史分页数据
    paginatedTextHistory() {
      const start = (this.textCurrentPage - 1) * this.textPageSize
      const end = start + this.textPageSize
      return this.textHistory.slice(start, end)
    },
    // 文件历史分页数据
    paginatedFileHistory() {
      const start = (this.fileCurrentPage - 1) * this.filePageSize
      const end = start + this.filePageSize
      return this.fileHistory.slice(start, end)
    },
    comparedText() {
      if (!this.inputText || !this.outputText) return ''
      return this.generateComparedHTML(this.inputText, this.outputText)
    },
    comparedText2() {
      if (!this.inputText2 || !this.outputText2) return ''
      return this.generateComparedHTML(this.inputText2, this.outputText2)
    },
    uploadAction() {
      return `${this.baseURL}/ai/reduceAigcFile`
    },
    uploadHeaders() {
      const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
      return {
        'token': user ? user.token : ''
      }
    }
  },
  created() {
    // 页面访问统计
    this.increasePageView()
    this.loadPointsConfig()
    this.loadHistoryData()
    // 不再自动加载历史记录，用户需要手动点击"历史数据"按钮加载
  },
  watch: {
    // 监听 activeTab 变化，在切换页面时保存文件处理历史
    activeTab(newTab, oldTab) {
      // 当从文件处理 tab 切换到其他 tab 时，保存历史记录
      if (oldTab === 'file' && newTab !== 'file') {
        // 只有在有文档数据且有处理进度时才保存
        if (this.docId && this.originalParagraphs.length > 0) {
          // 检查是否有任何已处理的段落
          const hasProcessedContent = this.processedParagraphs.some(p => p && p.content && p.content.trim() !== '')

          if (hasProcessedContent) {
            console.log('切换页面，保存文件处理历史记录')
            this.saveFileHistory()
          }
        }
      }
    }
  },
  methods: {
    // 页面访问统计
    increasePageView() {
      this.request.get('/pageView/increase', {
        params: { pageName: 'reduceAigc' }
      }).catch(() => {});
    },

    // 返回到上传文件页面
    handleBackToUpload() {
      this.$confirm('返回后当前处理进度将丢失，确定要返回吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 清空文档相关数据
        this.docId = null
        this.docFileName = ''
        this.docSelectedMode = ''
        this.originalParagraphs = []
        this.processedParagraphs = []
        this.processingIndex = -1
        this.parseStatus = 'none'
        this.uploadedFile = null
        this.fileWordCount = 0
        this.$message.success('已返回上传页面')
      }).catch(() => {})
    },
    // 计算积分消耗
    calculatePoints() {
      return Math.ceil(this.inputText.length / 300) * this.pointsConfig.reduceAigc
    },
    // 计算文件处理的积分消耗
    calculateFilePoints() {
      if (!this.fileWordCount) return 0
      const basePoints = Math.ceil(this.fileWordCount / 300) * this.pointsConfig.reduceAigc
      // 使用解析时选择的模式，而不是当前模式
      const selectedMode = this.docSelectedMode || this.mode
      return selectedMode === 'both' ? basePoints * 2 : basePoints
    },
    // 获取最终积分（用于实际扣费）
    getFinalPoints() {
      const basePoints = this.calculatePoints()
      return this.mode === 'both' ? basePoints * 2 : basePoints
    },
    async loadPointsConfig() {
      try {
        const response = await this.request.get('/ai/points-config')
        if (response.code === '200' && response.data) {
          this.pointsConfig = response.data
        }
      } catch (error) {
        console.error('加载积分配置失败:', error)
      }
    },
    async handleReduce() {
      if (!this.mode) {
        this.$message.warning('请先选择处理模式')
        return
      }
      if (!this.inputText.trim()) {
        this.$message.warning('请输入需要处理的文本')
        return
      }
      // 计算需要消耗的积分
      const requiredPoints = this.getFinalPoints()
      try {
        await this.$confirm(`此操作将消耗${requiredPoints}积分，是否继续？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch {
        this.$message.info('已取消操作')
        return
      }
      this.loading = true
      this.outputText = ''
      try {
        const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
        const token = user ? user.token : ''

        // 准备请求数据
        const requestData = {
          mode: this.mode,
          text: this.inputText
        }

        // 加密请求数据
        const jsonString = JSON.stringify(requestData)
        const encryptedData = encrypt(jsonString)

        const response = await fetch(`${this.baseURL}/ai/reduceAigc`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'token': token || '',
            'X-Encrypt': 'true'  // 添加加密标识
          },
          body: encryptedData  // 发送加密后的数据
        })
        if (!response.ok) {
          throw new Error('请求失败')
        }
        const reader = response.body.getReader()
        const decoder = new TextDecoder()
        let buffer = ''
        while (true) {
          const { done, value } = await reader.read()
          if (done) break
          buffer += decoder.decode(value, { stream: true })
          const lines = buffer.split('\n')
          buffer = lines.pop() || ''
          for (const line of lines) {
            if (line.startsWith('data:')) {
              let data = line.substring(5)
              if (data.startsWith(' ')) {
                data = data.substring(1)
              }
              if (data.startsWith('[PROGRESS]')) {
                const progressMsg = data.substring(10).trim()
                this.$message.info(progressMsg)
                continue
              }
              if (data.startsWith('[ERROR]')) {
                const errorMsg = data.substring(7).trim()
                this.$message.error(errorMsg || '处理失败')
                this.loading = false
                return
              }
              if (data.trim() === '[DONE]') {
                this.$message.success('处理完成')
                // 刷新积分
                this.$refreshPoints()
                continue
              }
              this.outputText += data.replace(/\\n/g, '\n')
            }
          }
        }
        this.outputText = this.outputText.replace(/\n{2,}/g, '\n')

        // 保存到历史记录
        this.saveTextHistory()
      } catch (error) {
        console.error('降重降AIGC失败:', error)
        this.$message.error('处理失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    handleClear() {
      this.$confirm('确定要清空所有内容吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit('clearReduceAigc')
        this.$message.success('已清空')
      }).catch(() => {})
    },
    handleCopy() {
      if (!this.outputText) return
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.outputText)
          .then(() => {
            this.$message.success('已复制到剪贴板')
          })
          .catch(() => {
            this.fallbackCopy()
          })
      } else {
        this.fallbackCopy()
      }
    },
    fallbackCopy() {
      const textarea = document.createElement('textarea')
      textarea.value = this.outputText
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        this.$message.success('已复制到剪贴板')
      } catch (err) {
        this.$message.error('复制失败')
      }
      document.body.removeChild(textarea)
    },
    handleCompare() {
      if (!this.outputText || !this.inputText) {
        this.$message.warning('请先生成优化结果')
        return
      }
      this.showCompare = !this.showCompare
    },
    // 第二组方法
    calculatePoints2() {
      return Math.ceil(this.inputText2.length / 300) * this.pointsConfig.reduceAigc
    },
    getFinalPoints2() {
      const basePoints = this.calculatePoints2()
      return this.mode === 'both' ? basePoints * 2 : basePoints
    },
    async handleReduce2() {
      if (!this.mode) {
        this.$message.warning('请先选择处理模式')
        return
      }
      if (!this.inputText2.trim()) {
        this.$message.warning('请输入需要处理的文本')
        return
      }
      const requiredPoints = this.getFinalPoints2()
      try {
        await this.$confirm(`此操作将消耗${requiredPoints}积分，是否继续？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch {
        this.$message.info('已取消操作')
        return
      }
      this.loading2 = true
      this.outputText2 = ''
      try {
        const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
        const token = user ? user.token : ''
        const requestData = {
          mode: this.mode,
          text: this.inputText2
        }
        const jsonString = JSON.stringify(requestData)
        const encryptedData = encrypt(jsonString)
        const response = await fetch(`${this.baseURL}/ai/reduceAigc`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'token': token || '',
            'X-Encrypt': 'true'
          },
          body: encryptedData
        })
        if (!response.ok) {
          throw new Error('请求失败')
        }
        const reader = response.body.getReader()
        const decoder = new TextDecoder()
        let buffer = ''
        while (true) {
          const { done, value } = await reader.read()
          if (done) break
          buffer += decoder.decode(value, { stream: true })
          const lines = buffer.split('\n')
          buffer = lines.pop() || ''
          for (const line of lines) {
            if (line.startsWith('data:')) {
              let data = line.substring(5)
              if (data.startsWith(' ')) {
                data = data.substring(1)
              }
              if (data.startsWith('[PROGRESS]')) {
                const progressMsg = data.substring(10).trim()
                this.$message.info(progressMsg)
                continue
              }
              if (data.startsWith('[ERROR]')) {
                const errorMsg = data.substring(7).trim()
                this.$message.error(errorMsg || '处理失败')
                this.loading2 = false
                return
              }
              if (data.trim() === '[DONE]') {
                this.$message.success('处理完成')
                this.$refreshPoints()
                continue
              }
              this.outputText2 += data.replace(/\\n/g, '\n')
            }
          }
        }
        this.outputText2 = this.outputText2.replace(/\n{2,}/g, '\n')
      } catch (error) {
        console.error('降重降AIGC失败:', error)
        this.$message.error('处理失败，请稍后重试')
      } finally {
        this.loading2 = false
      }
    },
    handleClear2() {
      this.$confirm('确定要清空所有内容吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit('clearReduceAigc2')
        this.$message.success('已清空')
      }).catch(() => {})
    },
    handleCopy2() {
      if (!this.outputText2) return
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.outputText2)
          .then(() => {
            this.$message.success('已复制到剪贴板')
          })
          .catch(() => {
            this.fallbackCopy2()
          })
      } else {
        this.fallbackCopy2()
      }
    },
    fallbackCopy2() {
      const textarea = document.createElement('textarea')
      textarea.value = this.outputText2
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        this.$message.success('已复制到剪贴板')
      } catch (err) {
        this.$message.error('复制失败')
      }
      document.body.removeChild(textarea)
    },
    handleCompare2() {
      if (!this.outputText2 || !this.inputText2) {
        this.$message.warning('请先生成优化结果')
        return
      }
      this.showCompare2 = !this.showCompare2
    },
    generateComparedHTML(original, optimized) {
      const cleanOriginal = original.trimEnd()
      const cleanOptimized = optimized.trimEnd()
      const diff = Diff.diffChars(cleanOriginal, cleanOptimized)
      let result = ''
      diff.forEach(part => {
        const text = this.escapeHtml(part.value)
        if (part.added) {
          result += `<span class="text-added">${text}</span>`
        } else if (part.removed) {
          result += `<span class="text-deleted">${text}</span>`
        } else {
          result += text
        }
      })
      return result
    },

    // 文件选择处理（不统计字数，只保存文件）
    async handleFileChange(file) {
      // beforeFileUpload 已经做了验证，这里直接处理
      this.uploadedFile = file.raw
      this.fileOutputText = ''
      this.fileWordCount = 0
      this.docId = null
      this.originalParagraphs = []
      this.processedParagraphs = []
      this.parseStatus = 'none'

      this.$message.success('文件已选择，请点击"开始解析文档"按钮')
    },

    // 格式化文件大小
    formatFileSize(bytes) {
      if (bytes < 1024) return bytes + ' B'
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB'
      return (bytes / (1024 * 1024)).toFixed(2) + ' MB'
    },

    // 解析文档（新方法 - 第一阶段）
    async handleParseDocument() {
      if (!this.uploadedFile) {
        this.$message.warning('请先上传文件')
        return
      }

      if (!this.mode) {
        this.$message.warning('请先选择处理模式')
        return
      }

      this.loading = true
      this.parseStatus = 'parsing'
      this.originalParagraphs = []
      this.processedParagraphs = []
      this.processingIndex = -1
      this.isFromHistory = false

      try {
        // 调用解析接口
        const formData = new FormData()
        formData.append('file', this.uploadedFile)
        formData.append('mode', this.mode)

        const uploadResponse = await this.request.post('/ai/parseDocParagraphs', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          skipEncrypt: true
        })

        if (uploadResponse.code !== '200') {
          this.$message.error(uploadResponse.msg || '文档解析失败')
          this.loading = false
          this.parseStatus = 'none'
          return
        }

        this.docId = uploadResponse.data.docId
        this.docFileName = uploadResponse.data.fileName
        this.docSelectedMode = this.mode // 保存解析时选择的模式
        this.originalParagraphs = uploadResponse.data.paragraphs.map(p => ({
          ...p,
          deleted: false,  // 新增：标记是否被删除
          selected: true   // 新增：默认全选
        })) || []

        // 计算总字数
        this.fileWordCount = this.originalParagraphs.reduce((sum, p) => sum + p.wordCount, 0)

        this.processedParagraphs = this.originalParagraphs.map(p => ({
          index: p.index,
          content: '',
          processing: false,
          showCompare: false
        }))

        this.parseStatus = 'parsed'
        this.$message.success(`文档解析成功，共 ${this.originalParagraphs.length} 个段落，${this.fileWordCount} 字`)

        // 更新实际消耗积分
        this.updateActualPoints()

      } catch (error) {
        console.error('文档解析失败:', error)
        this.$message.error('文档解析失败：' + (error.message || '未知错误'))
        this.parseStatus = 'none'
      } finally {
        this.loading = false
      }
    },

    // 删除段落（新方法）
    deleteParagraph(index) {
      this.$confirm('确定要删除这个段落吗？删除后将不会被处理。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.originalParagraphs[index].deleted = true
        this.originalParagraphs[index].selected = false
        this.updateActualPoints()
        this.$message.success('段落已标记为删除')
      }).catch(() => {})
    },

    // 恢复段落（新方法）
    restoreParagraph(index) {
      this.originalParagraphs[index].deleted = false
      this.originalParagraphs[index].selected = true
      this.updateActualPoints()
      this.$message.success('段落已恢复')
    },

    // 全选段落
    selectAllParagraphs() {
      this.originalParagraphs.forEach(para => {
        para.selected = true
        para.deleted = false
      })
      this.updateActualPoints()
      this.$message.success('已全选所有段落')
    },

    // 反选段落
    invertSelection() {
      this.originalParagraphs.forEach(para => {
        para.selected = !para.selected
        para.deleted = !para.selected
      })
      this.updateActualPoints()
      this.$message.success('已反选段落')
    },

    // 复选框变化处理
    handleCheckboxChange(index) {
      const para = this.originalParagraphs[index]
      para.deleted = !para.selected
      // 更新实际消耗积分
      this.updateActualPoints()
    },

    // 计算并更新实际消耗积分
    updateActualPoints() {
      const basePoints = Math.ceil(this.activeWordCount / 300) * this.pointsConfig.reduceAigc
      // 使用解析时选择的模式，而不是当前模式
      const selectedMode = this.docSelectedMode || this.mode
      this.actualPoints = selectedMode === 'both' ? basePoints * 2 : basePoints
    },

    // 处理选中的段落（新方法 - 第二阶段）
    async handleProcessSelectedParagraphs() {
      if (!this.docId) {
        this.$message.warning('请先解析文档')
        return
      }

      if (this.activeParagraphsCount === 0) {
        this.$message.warning('请至少保留一个段落进行处理')
        return
      }

      // 更新实际消耗积分
      this.updateActualPoints()

      // 计算需要消耗的积分
      const requiredPoints = this.actualPoints

      // 确认提示
      try {
        await this.$confirm(
          `将处理 ${this.activeParagraphsCount} 个段落，共 ${this.activeWordCount} 字，消耗 ${requiredPoints} 积分，是否继续？`,
          '确认处理',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
      } catch {
        this.$message.info('已取消操作')
        return
      }

      this.loading = true
      this.parseStatus = 'processing'

      try {
        // 获取未删除的段落索引
        const selectedIndexes = this.originalParagraphs
          .filter(p => !p.deleted)
          .map(p => p.index)

        // 调用处理接口
        await this.processSelectedParagraphsStream(selectedIndexes)

      } catch (error) {
        console.error('文档处理失败:', error)
        this.$message.error('文档处理失败：' + (error.message || '未知错误'))
        this.parseStatus = 'parsed'
      } finally {
        this.loading = false
      }
    },

    // 流式处理选中的段落
    async processSelectedParagraphsStream(selectedIndexes) {
      const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
      const token = user ? user.token : ''

      const response = await fetch(`${this.baseURL}/ai/processSelectedParagraphs`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'token': token || ''
        },
        body: JSON.stringify({
          docId: this.docId,
          selectedIndexes: selectedIndexes
        })
      })

      if (!response.ok) {
        throw new Error('请求失败')
      }

      const reader = response.body.getReader()
      const decoder = new TextDecoder()
      let buffer = ''

      // 批量更新缓冲区（性能优化）
      let pendingUpdates = {}
      let updateTimer = null
      let rafId = null

      // 批量更新函数 - 使用 requestAnimationFrame 优化
      const flushUpdates = () => {
        if (rafId) {
          cancelAnimationFrame(rafId)
        }

        rafId = requestAnimationFrame(() => {
          // 使用 Vue.set 批量更新，减少响应式开销
          Object.keys(pendingUpdates).forEach(index => {
            const para = this.processedParagraphs[index]
            if (para) {
              const newContent = (para.content || '') + pendingUpdates[index]
              this.$set(this.processedParagraphs[index], 'content', newContent)
            }
          })
          pendingUpdates = {}
          rafId = null
        })
      }

      // 定时批量更新（150ms一次，平衡流畅度和性能）
      const scheduleUpdate = () => {
        if (updateTimer) {
          clearTimeout(updateTimer)
        }
        updateTimer = setTimeout(() => {
          flushUpdates()
          updateTimer = null
        }, 150)
      }

      while (true) {
        const { done, value } = await reader.read()
        if (done) {
          // 确保最后的更新被刷新
          if (Object.keys(pendingUpdates).length > 0) {
            flushUpdates()
          }
          break
        }

        buffer += decoder.decode(value, { stream: true })
        const lines = buffer.split('\n')
        buffer = lines.pop() || ''

        for (const line of lines) {
          if (line.startsWith('data:')) {
            let data = line.substring(5).trim()

            try {
              // 清理控制字符，避免 JSON.parse 失败
              // 保留换行符 \n，但移除其他控制字符（如制表符 \t）
              data = data.replace(/[\x00-\x08\x0B-\x0C\x0E-\x1F\x7F]/g, '')

              const jsonData = JSON.parse(data)

              if (jsonData.type === 'info') {
                // 接收后端返回的字数和积分信息
                this.fileWordCount = jsonData.wordCount
              } else if (jsonData.type === 'progress') {
                const index = jsonData.paragraphIndex
                if (this.processedParagraphs[index]) {
                  this.$set(this.processedParagraphs[index], 'processing', false)
                }
                // 进度由 computed 属性自动计算，无需手动赋值
              } else if (jsonData.type === 'content') {
                const index = jsonData.paragraphIndex

                // 初始化段落数据
                if (!this.processedParagraphs[index]) {
                  this.$set(this.processedParagraphs, index, {
                    content: '',
                    processing: true,
                    showCompare: false
                  })
                }

                if (!this.processedParagraphs[index].content) {
                  this.$set(this.processedParagraphs[index], 'processing', true)
                  this.processingIndex = index
                }

                // 累积到批量更新缓冲区（性能优化）
                if (!pendingUpdates[index]) {
                  pendingUpdates[index] = ''
                }
                pendingUpdates[index] += jsonData.content.replace(/\\n/g, '\n')

                // 调度批量更新
                scheduleUpdate()

              } else if (jsonData.type === 'complete') {
                const index = jsonData.paragraphIndex

                // 立即刷新该段落的待更新内容
                if (pendingUpdates[index]) {
                  const para = this.processedParagraphs[index]
                  if (para) {
                    const newContent = (para.content || '') + pendingUpdates[index]
                    this.$set(this.processedParagraphs[index], 'content', newContent)
                  }
                  delete pendingUpdates[index]
                }

                if (this.processedParagraphs[index]) {
                  this.$set(this.processedParagraphs[index], 'processing', false)
                }
              } else if (jsonData.type === 'done') {
                // 确保所有待更新内容都被刷新
                if (Object.keys(pendingUpdates).length > 0) {
                  flushUpdates()
                }

                this.processingIndex = -1
                this.parseStatus = 'completed'
                this.$message.success('文档处理完成')
                this.$refreshPoints()
                this.saveFileHistory()
              } else if (jsonData.type === 'error') {
                // 如果有段落索引，显示具体段落；否则显示通用错误
                if (jsonData.paragraphIndex !== undefined && jsonData.paragraphIndex !== null) {
                  this.$message.error(`段落 ${jsonData.paragraphIndex + 1} 处理失败：${jsonData.message}`)

                  // 标记该段落处理失败
                  if (this.processedParagraphs[jsonData.paragraphIndex]) {
                    this.$set(this.processedParagraphs[jsonData.paragraphIndex], 'processing', false)
                    this.$set(this.processedParagraphs[jsonData.paragraphIndex], 'error', true)
                  }
                } else {
                  this.$message.error(`处理失败：${jsonData.message}`)
                }
              }
            } catch (e) {
              console.warn('解析数据失败:', data, e)
            }
          }
        }
      }

      this.processingIndex = -1
    },



    // 重新生成某个段落
    async regenerateParagraph(index) {
      if (!this.docId) {
        this.$message.warning('文档会话已失效，请重新上传')
        return
      }

      this.$confirm('确定要重新生成这个段落吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // 初始化段落对象（如果不存在）
        if (!this.processedParagraphs[index]) {
          this.$set(this.processedParagraphs, index, {})
        }

        // 设置状态
        this.$set(this.processedParagraphs[index], 'processing', true)
        this.$set(this.processedParagraphs[index], 'content', '')

        try {
          const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
          const token = user ? user.token : ''

          const response = await fetch(`${this.baseURL}/ai/regenerateDocParagraph`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'token': token || ''
            },
            body: JSON.stringify({
              docId: this.docId,
              paragraphIndex: index
            })
          })

          if (!response.ok) {
            throw new Error('请求失败')
          }

          const reader = response.body.getReader()
          const decoder = new TextDecoder()
          let buffer = ''

          while (true) {
            const { done, value } = await reader.read()
            if (done) break

            buffer += decoder.decode(value, { stream: true })
            const lines = buffer.split('\n')
            buffer = lines.pop() || ''

            for (const line of lines) {
              if (line.startsWith('data:')) {
                const data = line.substring(5).trim()

                if (data === '[DONE]') {
                  this.$message.success('段落重新生成完成')
                  this.updateFileHistoryParagraph(index, this.processedParagraphs[index].content)
                  continue
                }

                if (data.startsWith('[ERROR]')) {
                  this.$message.error(data.substring(7).trim())
                  continue
                }

                // 解析JSON格式
                try {
                  // 清理控制字符，避免 JSON.parse 失败
                  const cleanData = data.replace(/[\x00-\x08\x0B-\x0C\x0E-\x1F\x7F]/g, '')
                  const jsonData = JSON.parse(cleanData)
                  if (jsonData.type === 'content' && jsonData.content) {
                    const currentContent = this.processedParagraphs[index].content || ''
                    this.$set(this.processedParagraphs[index], 'content', currentContent + jsonData.content.replace(/\\n/g, '\n'))
                  }
                } catch (e) {
                  // 纯文本格式
                  const currentContent = this.processedParagraphs[index].content || ''
                  this.$set(this.processedParagraphs[index], 'content', currentContent + data.replace(/\\n/g, '\n'))
                }
              }
            }
          }
        } catch (error) {
          console.error('重新生成段落失败:', error)
          this.$message.error('重新生成失败：' + (error.message || '未知错误'))
        } finally {
          this.$set(this.processedParagraphs[index], 'processing', false)
        }
      }).catch(() => {})
    },

    // 更新历史记录中的段落数据
    updateFileHistoryParagraph(paragraphIndex, newContent) {
      if (!this.docId) return

      try {
        // 查找当前文档在历史记录中的位置
        const historyIndex = this.fileHistory.findIndex(item => item.docId === this.docId)

        if (historyIndex !== -1) {
          // 更新历史记录中的段落内容
          if (this.fileHistory[historyIndex].processedParagraphs &&
              this.fileHistory[historyIndex].processedParagraphs[paragraphIndex]) {
            this.fileHistory[historyIndex].processedParagraphs[paragraphIndex].content = newContent

            // 保存到 localStorage
            localStorage.setItem('reduceAigc_fileHistory', JSON.stringify(this.fileHistory))

            console.log(`已更新历史记录中段落 ${paragraphIndex} 的内容`)
          }
        }
      } catch (error) {
        console.error('更新历史记录失败:', error)
      }
    },

    // 切换对比视图
    toggleCompare(index) {
      if (!this.processedParagraphs[index]) {
        this.$message.warning('段落数据未加载，请稍后再试')
        return
      }

      const currentShowCompare = this.processedParagraphs[index].showCompare || false
      this.$set(this.processedParagraphs[index], 'showCompare', !currentShowCompare)
    },

    // 获取对比文本（文件上传处理）
    getComparedText(index) {
      const original = this.originalParagraphs[index]?.originalContent
      const processed = this.processedParagraphs[index]?.content

      if (!original || !processed) {
        return '<span style="color: #999;">暂无对比数据</span>'
      }

      // 使用 Diff 库生成对比（与粘贴文本处理保持一致）
      const cleanOriginal = original.trimEnd()
      const cleanProcessed = processed.trimEnd()
      const diff = Diff.diffChars(cleanOriginal, cleanProcessed)
      let html = ''

      diff.forEach(part => {
        const text = this.escapeHtml(part.value)
        if (part.added) {
          html += `<span class="text-added">${text}</span>`
        } else if (part.removed) {
          html += `<span class="text-deleted">${text}</span>`
        } else {
          html += text
        }
      })

      return html
    },

    // 转义HTML
    escapeHtml(text) {
      const div = document.createElement('div')
      div.textContent = text
      return div.innerHTML
    },

    // 导出处理后的文档
    async handleExportDoc() {
      if (!this.docId) {
        this.$message.warning('没有可导出的文档')
        return
      }

      try {
        const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
        const token = user ? user.token : ''

        const response = await fetch(`${this.baseURL}/ai/exportProcessedDoc`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'token': token || ''
          },
          body: JSON.stringify({
            docId: this.docId
          })
        })

        if (!response.ok) {
          throw new Error('导出失败')
        }

        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        // 修改文件名格式为：改后-原文件名.docx
        const originalName = this.docFileName.replace('.docx', '')
        link.download = `改后-${originalName}.docx`
        link.click()
        window.URL.revokeObjectURL(url)

        this.$message.success('文档导出成功，您可以在3天内通过历史记录多次下载')

        // 导出后不清理数据，保留docId以便用户多次下载
        // this.docId = null
        // this.originalParagraphs = []
        // this.processedParagraphs = []
        // this.uploadedFile = null
        // this.isFromHistory = false

      } catch (error) {
        console.error('导出文档失败:', error)
        this.$message.error('导出失败：' + (error.message || '未知错误'))
      }
    },

    // 文件上传前的验证
    beforeFileUpload(file) {
      // 检查文件扩展名
      const fileName = file.name.toLowerCase()
      if (!fileName.endsWith('.docx')) {
        this.$message.error('仅支持DOCX格式的文件，请不要通过修改后缀名来伪造文件格式')
        return false
      }

      // 检查文件MIME类型
      const validMimeTypes = [
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/octet-stream'
      ]
      if (file.type && !validMimeTypes.includes(file.type)) {
        this.$message.error('文件类型不正确，请上传真正的DOCX文件，而不是修改后缀名得到的文件')
        return false
      }

      // 检查文件大小（最大50MB）
      const isLt50M = file.size / 1024 / 1024 < 50
      if (!isLt50M) {
        this.$message.error('文件大小不能超过 50MB!')
        return false
      }

      // 检查文件是否为空
      if (file.size === 0) {
        this.$message.error('文件为空，请上传有效的DOCX文件')
        return false
      }

      return true
    },
    handleFileSuccess(response, file) {
      this.loading = false
      if (response.code === '200') {
        this.fileOutputText = response.data
        this.$message.success('文件处理成功')
        this.$root.$emit('refresh-points')
      } else {
        this.$message.error(response.msg || '文件处理失败')
      }
    },
    handleFileError(err) {
      this.loading = false
      this.$message.error('文件上传失败')
      console.error(err)
    },
    handleDownload() {
      if (!this.fileOutputText) return

      const blob = new Blob([this.fileOutputText], { type: 'text/plain;charset=utf-8' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `处理结果_${Date.now()}.txt`
      link.click()
      URL.revokeObjectURL(link.href)
      this.$message.success('下载成功')
    },

    // ==================== 历史记录相关方法 ====================

    // 加载历史数据
    loadHistoryData() {
      try {
        const textHistoryStr = localStorage.getItem('reduceAigc_textHistory')
        const fileHistoryStr = localStorage.getItem('reduceAigc_fileHistory')

        this.textHistory = textHistoryStr ? JSON.parse(textHistoryStr) : []
        this.fileHistory = fileHistoryStr ? JSON.parse(fileHistoryStr) : []
      } catch (error) {
        console.error('加载历史数据失败:', error)
        this.textHistory = []
        this.fileHistory = []
      }
    },

    // 保存文本处理历史（最多20条）
    saveTextHistory() {
      if (!this.inputText || !this.outputText) return

      const historyItem = {
        timestamp: this.formatTimestamp(new Date()),
        mode: this.mode,
        inputText: this.inputText,
        outputText: this.outputText,
        inputLength: this.inputText.length,
        outputLength: this.outputText.length,
        points: this.getFinalPoints()
      }

      // 添加到历史记录开头
      this.textHistory.unshift(historyItem)

      // 只保留最近20条
      if (this.textHistory.length > 20) {
        this.textHistory = this.textHistory.slice(0, 20)
      }

      // 保存到localStorage
      try {
        localStorage.setItem('reduceAigc_textHistory', JSON.stringify(this.textHistory))
      } catch (error) {
        console.error('保存文本历史失败:', error)
        // 如果存储空间不足，删除最旧的记录后重试
        if (error.name === 'QuotaExceededError') {
          this.textHistory = this.textHistory.slice(0, 10)
          try {
            localStorage.setItem('reduceAigc_textHistory', JSON.stringify(this.textHistory))
          } catch (e) {
            console.error('保存失败，存储空间不足')
          }
        }
      }
    },

    // 保存文件处理历史（最多10条，因为内容较大）
    saveFileHistory() {
      if (!this.docId || !this.originalParagraphs.length) return

      // 正确保存 processedParagraphs，保持索引对应关系
      const processedParagraphsToSave = []
      let actualProcessedCount = 0

      this.processedParagraphs.forEach((p, index) => {
        if (p) {
          processedParagraphsToSave[index] = {
            index: index,
            content: p.content || '',
            processing: false,
            showCompare: false
          }
          // 统计实际有内容的段落数
          if (p.content && p.content.trim() !== '') {
            actualProcessedCount++
          }
        }
      })

      const historyItem = {
        timestamp: this.formatTimestamp(new Date()),
        mode: this.docSelectedMode || this.mode,
        fileName: this.docFileName,
        wordCount: this.fileWordCount,
        points: this.actualPoints,
        progress: 0,  // 标记为 0（切换页面后无法获取实时进度）
        docId: this.docId,
        originalParagraphs: this.originalParagraphs,
        processedParagraphs: processedParagraphsToSave,
        paragraphsCount: this.originalParagraphs.length,
        processedCount: actualProcessedCount
      }

      console.log('保存文件历史，已处理:', actualProcessedCount, '总数:', this.activeParagraphsCount)

      // 添加到历史记录开头
      this.fileHistory.unshift(historyItem)

      // 只保留最近10条
      if (this.fileHistory.length > 10) {
        this.fileHistory = this.fileHistory.slice(0, 10)
      }

      // 保存到localStorage
      try {
        localStorage.setItem('reduceAigc_fileHistory', JSON.stringify(this.fileHistory))
      } catch (error) {
        console.error('保存文件历史失败:', error)
        if (error.name === 'QuotaExceededError') {
          this.fileHistory = this.fileHistory.slice(0, 5)
          try {
            localStorage.setItem('reduceAigc_fileHistory', JSON.stringify(this.fileHistory))
          } catch (e) {
            console.error('保存失败，存储空间不足')
          }
        }
      }
    },

    // 加载文本历史记录
    loadTextHistory(item) {
      this.$confirm('加载历史记录将覆盖当前内容，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 切换到文本处理tab
        this.activeTab = 'text'

        // 加载数据
        this.mode = item.mode
        this.inputText = item.inputText
        this.outputText = item.outputText

        // 关闭对话框
        this.showHistoryDialog = false

        this.$message.success('历史记录已加载')
      }).catch(() => {})
    },

    // 加载文件历史记录
    loadFileHistory(item) {
      this.$confirm('加载历史记录将覆盖当前内容，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 切换到文件处理tab
        this.activeTab = 'file'

        // 加载数据
        this.mode = item.mode
        this.docSelectedMode = item.mode
        this.docId = item.docId
        this.docFileName = item.fileName
        this.fileWordCount = item.wordCount
        this.actualPoints = item.points
        this.originalParagraphs = (item.originalParagraphs || []).map(p => ({
          ...p,
          selected: p.selected !== undefined ? p.selected : !p.deleted,
          deleted: p.deleted || false
        }))

        // 初始化 processedParagraphs，确保每个段落都有正确的结构
        this.processedParagraphs = []
        let loadedProcessedCount = 0

        if (item.processedParagraphs && Array.isArray(item.processedParagraphs)) {
          // 直接使用索引对应关系恢复数据
          item.processedParagraphs.forEach((p, index) => {
            if (p && p.content !== undefined) {
              this.$set(this.processedParagraphs, index, {
                index: index,
                content: p.content || '',
                processing: false,
                showCompare: false
              })
              // 统计有内容的段落
              if (p.content && p.content.trim() !== '') {
                loadedProcessedCount++
              }
            }
          })
        }

        // 计算真实进度
        const activeCount = this.activeParagraphsCount
        const realProgress = activeCount > 0 ? Math.round((loadedProcessedCount / activeCount) * 100) : 0

        // 更新历史记录中的进度
        const historyIndex = this.fileHistory.findIndex(h => h.docId === item.docId && h.timestamp === item.timestamp)
        if (historyIndex !== -1) {
          this.fileHistory[historyIndex].progress = realProgress
          this.fileHistory[historyIndex].processedCount = loadedProcessedCount
          // 保存更新后的历史记录
          try {
            localStorage.setItem('reduceAigc_fileHistory', JSON.stringify(this.fileHistory))
            console.log('已更新历史记录进度:', realProgress, '%')
          } catch (error) {
            console.error('更新历史记录失败:', error)
          }
        }

        // 设置解析状态
        this.parseStatus = realProgress >= 100 ? 'completed' : 'parsed'
        this.processingIndex = -1

        // 清空上传的文件
        this.uploadedFile = null

        // 关闭对话框
        this.showHistoryDialog = false

        this.$message.success('历史记录已加载')
      }).catch(() => {})
    },

    // 从历史记录下载文档
    async downloadHistoryDoc(item) {
      if (!item.docId) {
        this.$message.warning('文档ID不存在')
        return
      }

      try {
        const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
        const token = user ? user.token : ''

        this.$message.info('正在下载文档...')

        const response = await fetch(`${this.baseURL}/ai/exportProcessedDoc`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'token': token || ''
          },
          body: JSON.stringify({
            docId: item.docId
          })
        })

        if (!response.ok) {
          if (response.status === 500) {
            this.$message.error('文档已过期或不存在，请重新处理')
          } else {
            throw new Error('下载失败')
          }
          return
        }

        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        // 修改文件名格式为：改后-原文件名.docx
        const originalName = item.fileName.replace('.docx', '')
        link.download = `改后-${originalName}.docx`
        link.click()
        window.URL.revokeObjectURL(url)

        this.$message.success('文档下载成功')

      } catch (error) {
        console.error('下载文档失败:', error)
        this.$message.error('下载失败：' + (error.message || '未知错误'))
      }
    },

    // 查看文件历史信息
    viewFileHistoryInfo(item) {
      const infoHtml = `
        <div style="text-align: left; line-height: 1.8;">
          <p><strong>文件名：</strong>${item.fileName}</p>
          <p><strong>处理时间：</strong>${item.timestamp}</p>
          <p><strong>处理模式：</strong>${this.getModeLabel(item.mode)}</p>
          <p><strong>文档字数：</strong>${item.wordCount} 字</p>
          <p><strong>段落总数：</strong>${item.paragraphsCount} 段</p>
          <p><strong>已处理段落：</strong>${item.processedCount} 段</p>
          <p><strong>处理进度：</strong>${item.progress === 0 ? '处理中（点击加载查看实际进度）' : item.progress + '%'}</p>
          <p><strong>消耗积分：</strong>${item.points} 分</p>
          <p style="color: #909399; font-size: 12px; margin-top: 12px;">
            <i class="el-icon-info"></i> 注：为节省存储空间，文件历史不保存完整的处理结果内容，仅保存统计信息供查看。
          </p>
        </div>
      `

      this.$alert(infoHtml, '文件处理信息', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定'
      })
    },

    // 删除文本历史记录
    deleteTextHistory(index) {
      this.$confirm('确定要删除这条历史记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.textHistory.splice(index, 1)
        localStorage.setItem('reduceAigc_textHistory', JSON.stringify(this.textHistory))

        // 如果当前页没有数据了，跳转到上一页
        const totalPages = Math.ceil(this.textHistory.length / this.textPageSize)
        if (this.textCurrentPage > totalPages && totalPages > 0) {
          this.textCurrentPage = totalPages
        }

        this.$message.success('已删除')
      }).catch(() => {})
    },

    // 判断历史记录是否已过期（超过3天）
    isHistoryExpired(timestamp) {
      if (!timestamp) return true

      try {
        // 解析时间戳格式：YYYY-MM-DD HH:mm:ss
        const historyDate = new Date(timestamp.replace(/-/g, '/'))
        const now = new Date()
        const diffTime = now - historyDate
        const diffDays = diffTime / (1000 * 60 * 60 * 24)

        // 超过3天视为过期
        return diffDays > 3
      } catch (error) {
        console.error('解析时间戳失败:', error)
        return true
      }
    },

    // 删除文件历史记录
    deleteFileHistory(index) {
      this.$confirm('确定要删除这条历史记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fileHistory.splice(index, 1)
        localStorage.setItem('reduceAigc_fileHistory', JSON.stringify(this.fileHistory))

        // 如果当前页没有数据了，跳转到上一页
        const totalPages = Math.ceil(this.fileHistory.length / this.filePageSize)
        if (this.fileCurrentPage > totalPages && totalPages > 0) {
          this.fileCurrentPage = totalPages
        }

        this.$message.success('已删除')
      }).catch(() => {})
    },

    // 格式化时间戳
    formatTimestamp(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    // 获取模式标签类型
    getModeTagType(mode) {
      const typeMap = {
        'reduce': 'primary',
        'aigc': '',
        'both': 'success',
        'academic': 'danger'
      }
      return typeMap[mode] || 'info'
    },

    // 获取模式标签文本
    getModeLabel(mode) {
      const labelMap = {
        'reduce': '降重复率',
        'aigc': '降AIGC率',
        'both': '降重+降AIGC',
        'academic': '学术润色'
      }
      return labelMap[mode] || mode
    },

    // 文本历史分页切换
    handleTextPageChange(page) {
      this.textCurrentPage = page
    },

    // 文件历史分页切换
    handleFilePageChange(page) {
      this.fileCurrentPage = page
    },

    // 查看文本详情
    viewTextDetail(item) {
      this.currentDetailItem = item
      this.detailShowCompare = false
      this.showDetailDialog = true
    },

    // 复制详情文本
    copyDetailText(text) {
      if (!text) return

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text)
          .then(() => {
            this.$message.success('已复制到剪贴板')
          })
          .catch(() => {
            this.fallbackCopyText(text)
          })
      } else {
        this.fallbackCopyText(text)
      }
    },

    // 降级复制方法
    fallbackCopyText(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        this.$message.success('已复制到剪贴板')
      } catch (err) {
        this.$message.error('复制失败')
      }
      document.body.removeChild(textarea)
    }
  }
}
</script>

<style scoped>
.reduce-aigc-page {
  display: flex;
  height: calc(100vh - 118px);
  background: #f5f5f5;
  overflow: hidden;
  gap: 2px;
}

/* 左侧编辑器面板 */
.editor-panel {
  width: 360px;
  background: #fff;
  border-right: none;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.panel-header {
  padding: 12px 24px;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.btn-history {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 13px;
  color: #4f46e5;
  background: #fff;
  border: 1px solid #4f46e5;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-history:hover {
  background: #4f46e5;
  color: #fff;
}

.btn-history svg {
  width: 16px;
  height: 16px;
}

.panel-icon {
  width: 20px;
  height: 20px;
  color: #4f46e5;
}

.config-panel {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

/* 顶部提示文字 */
.top-hint {
  background: #eff6ff;
  padding: 16px 20px;
  margin-bottom: 20px;
  text-align: center;
}

.top-hint p {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #1e40af;
  line-height: 1.6;
}

/* 模式选择卡片 */
.mode-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.mode-card {
  background: #fff;
  border: 2px solid #e5e7eb;
  padding: 14px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  gap: 12px;
  position: relative;
}

.mode-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.mode-card.active {
  border-color: #2563eb;
  background: #eff6ff;
}

.card-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.card-content {
  flex: 1;
  min-width: 0;
}

.card-content h3 {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 4px;
}

.card-content p {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.5;
  margin: 0;
}

.check-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  background: #2563eb;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.check-icon svg {
  width: 12px;
  height: 12px;
}

/* 提示区域 */
.tips-section {
  margin-top: 20px;
}

.tip-card {
  background: #fffbeb;
  border: 1px solid #fde68a;
  padding: 16px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.tip-card .el-icon-info {
  font-size: 18px;
  color: #f59e0b;
  flex-shrink: 0;
  margin-top: 0;
}

.tip-content h4 {
  font-size: 14px;
  font-weight: 600;
  color: #92400e;
}

.tip-content ul {
  margin: 0;
  padding-left: 18px;
}

.tip-content li {
  font-size: 13px;
  color: #78350f;
  line-height: 1.6;
  margin: 4px 0;
}

/* 右侧预览面板 */
.preview-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f9fafb;
  margin-left: 10px;
  border-left: 1px solid #d1d5db;
}

.tabs {
  display: flex;
  gap: 24px;
  padding: 0 24px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.tab {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 0;
  font-size: 16px;
  font-weight: 400;
  color: #6b7280;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: all 0.2s;
}

.tab svg { width: 22px; height: 22px; }
.tab:hover { color: #374151; }
.tab.active { color: #4f46e5; border-bottom-color: #4f46e5; }

.preview-content {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
}

/* 文件上传区域 */
.file-upload-container {
  padding: 24px;
}

.file-upload-area {
  max-width: 800px;
  margin: 0 auto;
}

/* 固定的文档处理结果标题栏（在tabs下方） */
.result-header-fixed {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  min-height: 50px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  width: 100%;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 10;
}

.back-btn {
  font-size: 14px;
  color: #606266;
  padding: 8px 8px;
  margin-right: 0;
  background-color: #f5f7fa;
  border-radius: 0;
  transition: all 0.3s;
}

.back-btn:hover {
  color: #fff;
  background-color: #7275f2;
}

.back-btn i {
  margin-right: 4px;
}

/* 分割线 */
.divider {
  width: 1px;
  height: 24px;
  background-color: #dcdfe6;
}

/* 移除页面所有按钮的圆角 */
.reduce-aigc-page >>> .el-button {
  border-radius: 0 !important;
}

/* 移除页面所有元素的圆角 */
.reduce-aigc-page >>> .el-card,
.reduce-aigc-page >>> .el-dialog,
.reduce-aigc-page >>> .el-input,
.reduce-aigc-page >>> .el-input__inner,
.reduce-aigc-page >>> .el-textarea,
.reduce-aigc-page >>> .el-textarea__inner,
.reduce-aigc-page >>> .el-tag,
.reduce-aigc-page >>> .el-progress,
.reduce-aigc-page >>> .el-progress-bar,
.reduce-aigc-page .mode-card,
.reduce-aigc-page .tip-card,
.reduce-aigc-page .history-item,
.reduce-aigc-page .para-section,
.reduce-aigc-page .file-info,
.reduce-aigc-page .compare-view,
.reduce-aigc-page .detail-text-section,
.reduce-aigc-page .paragraph-pair,
.reduce-aigc-page .para-section.original,
.reduce-aigc-page .para-section.processed,
.reduce-aigc-page .para-section.compare,
.reduce-aigc-page .deleted-tip,
.reduce-aigc-page .para-content,
.reduce-aigc-page >>> * {
  border-radius: 0 !important;
}

.result-header-fixed .header-left {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1;
}

.result-header-fixed h3 {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin: 0;
  white-space: nowrap;
}

/* 文档处理结果展示 */
.doc-process-result {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1;
}

.header-left h3 {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin: 0;
  white-space: nowrap;
}

/* 字数信息 */
.word-count-info {
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

/* 文件名信息组 */
.header-info-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* 文件名信息 */
.file-name-info {
  display: flex;
  align-items: center;
  gap: 6px;
}

.file-name-info .mode-tag {
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 4px;
  white-space: nowrap;
}

/* 降重复率 - 蓝色 */
.file-name-info .mode-tag.mode-reduce {
  color: #0284c7;
  background: #e0f2fe;
}

/* 降AIGC率 - 紫色 */
.file-name-info .mode-tag.mode-aigc {
  color: #7c3aed;
  background: #ede9fe;
}

/* 降重+降AIGC - 绿色 */
.file-name-info .mode-tag.mode-both {
  color: #16a34a;
  background: #dcfce7;
}

/* 学术润色 - 橙色 */
.file-name-info .mode-tag.mode-academic {
  color: #ea580c;
  background: #ffedd5;
}

.file-name-info i {
  font-size: 16px;
  color: #2563eb;
  flex-shrink: 0;
}

.file-name-info .file-name {
  font-size: 14px;
  color: #1f2937;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 400px;
}

/* 统计信息行（字数和积分） */
.stats-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.progress-bar-container {
  width: 150px;
  display: flex !important;
  align-items: center !important;
}

.progress-bar-container >>> .el-progress {
  width: 100%;
  display: flex;
  align-items: center;
}

.progress-bar-container >>> .el-progress-bar {
  flex: 1;
  padding-right: 50px;
  margin-right: -50px;
}

.progress-bar-container >>> .el-progress-bar__outer {
  background-color: #ebeef5;
}

.progress-bar-container >>> .el-progress-bar__inner {
  transition: width 0.6s ease;
}

.progress-bar-container >>> .el-progress__text {
  font-size: 14px !important;
  font-weight: 600;
  margin-left: 10px;
}

.word-count-info .label {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}

.word-count-info .count {
  font-size: 14px;
  color: #1f2937;
  font-weight: 600;
}

.word-count-info .unit {
  font-size: 13px;
  color: #6b7280;
}

/* 积分信息 */
.points-info {
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.points-info .label {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}

.points-info .count {
  font-size: 14px;
  color: #f59e0b;
  font-weight: 600;
}

.points-info .unit {
  font-size: 13px;
  color: #6b7280;
}

.progress-inline {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  max-width: 500px;
}

.progress-text {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
  white-space: nowrap;
}

.complete-tag {
  font-size: 13px;
  color: #10b981;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

/* 文档垂直展示视图 */
.doc-vertical-view {
  flex: 1;
  overflow-y: auto;
  background: #f9fafb;
  position: relative;
}

/* 全选/反选工具栏 */
.selection-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 0px;
  background: #f9fafb;
  border-bottom: 2px solid #e5e7eb;
  margin-bottom: 16px;
  border-radius: 8px 8px 0 0;
}

/* Tab 切换按钮组 */
.view-tabs {
  display: flex;
  gap: 8px;
}

.tab-btn {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.tab-btn:hover {
  color: #7275f2;
  border-color: #7275f2;
  background: #f5f3ff;
}

.tab-btn.active {
  color: #ffffff;
  background: #7275f2;
  border-color: #7275f2;
  box-shadow: 0 2px 8px rgba(114, 117, 242, 0.3);
}

.tab-btn i {
  font-size: 16px;
}

/* 全选/反选按钮组 */
.selection-actions {
  display: flex;
  gap: 8px;
}

.selection-toolbar .el-button {
  padding: 8px 16px;
  font-size: 14px;
  color: #ffffff;
  border: none;
  transition: all 0.3s ease;
}

/* 全选按钮 - 绿色 */
.selection-toolbar .btn-select-all {
  background-color: #10b981;
}

.selection-toolbar .btn-select-all:hover {
  background-color: #059669;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

/* 反选按钮 - 橙色 */
.selection-toolbar .btn-invert {
  background-color: #f59e0b;
}

.selection-toolbar .btn-invert:hover {
  background-color: #d97706;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
}

.selection-toolbar .el-button:active {
  transform: translateY(0);
}

.paragraphs-vertical-list {
  padding: 0;
}

.paragraph-pair {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 24px;
  overflow: hidden;
  transition: all 0.2s;
  /* 性能优化：告诉浏览器该元素的变化不会影响外部布局 */
  contain: layout style paint;
  /* 启用硬件加速 */
  will-change: transform;
}

.paragraph-pair:first-child {
  margin-top: 0;
}

.paragraph-pair:last-child {
  margin-bottom: 0;
}

.paragraph-pair.active {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.para-section {
  padding: 16px 20px;
  /* 性能优化：减少重排范围 */
  contain: layout style;
}

.para-section.original {
  background: #f9fafb;
  border-bottom: 2px solid #e5e7eb;
}

.para-section.original.deleted {
  background: #fee2e2;
  opacity: 0.6;
}

.para-content.deleted-content {
  text-decoration: line-through;
  color: #9ca3af;
}

.deleted-tip {
  margin-top: 8px;
  padding: 8px 12px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 4px;
  color: #dc2626;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.deleted-tip i {
  font-size: 16px;
}

.para-section.processed {
  background: #fff;
}

.para-section.processed.processing {
  background: #eff6ff;
}

.para-section.compare {
  background: #fffbeb;
  border-top: 2px solid #fbbf24;
}

.para-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
}

/* 复选框样式 */
.para-checkbox {
  margin-right: 4px;
}

.para-checkbox >>> .el-checkbox__inner {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1px solid #4b5563;
}

.para-checkbox >>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #ffffff;
  border-color: #4b5563;
}

/* 未选中时隐藏勾勾 */
.para-checkbox >>> .el-checkbox__inner::after {
  border: 2px solid #10b981;
  border-left: 0;
  border-top: 0;
  height: 8px;
  left: 50%;
  top: 50%;
  width: 4px;
  transform: translate(-50%, -60%) rotate(45deg);
  transform-origin: center;
  opacity: 0;
  transition: opacity 0.2s ease;
}

/* 选中时显示勾勾 */
.para-checkbox >>> .el-checkbox__input.is-checked .el-checkbox__inner::after {
  opacity: 1;
}

.para-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  padding: 2px 8px;
  background: #e5e7eb;
  border-radius: 4px;
}

.para-section.original .para-label {
  background: #dbeafe;
  color: #1e40af;
}

.para-section.processed .para-label {
  background: #d1fae5;
  color: #065f46;
}

.para-index {
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
}

.para-words {
  font-size: 12px;
  color: #9ca3af;
  margin-left: auto;
}

.para-words-inline {
  font-size: 14px;
  color: #9ca3af;
  margin-left: 8px;
}

.processing-tag {
  font-size: 12px;
  color: #2563eb;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
}

.para-content {
  font-size: 14px;
  line-height: 1.8;
  color: #1f2937;
  white-space: pre-wrap;
  word-break: break-word;
}

.para-content.empty {
  color: #9ca3af;
  font-style: italic;
}

.file-upload-area >>> .el-upload {
  width: 100%;
}

.file-upload-area >>> .el-upload-dragger {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.file-upload-area >>> .el-icon-upload {
  font-size: 67px;
  color: #c0c4cc;
  margin: 0;
  line-height: 1;
}

.file-upload-area >>> .el-upload__text {
  color: #606266;
  font-size: 14px;
  margin-top: 20px;
}

.file-upload-area >>> .el-upload__tip {
  font-size: 12px;
  color: #909399;
  margin-top: 10px;
}

.file-info {
  margin-top: 20px;
  padding: 16px;
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.file-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.file-name {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #606266;
}

.file-name i {
  font-size: 20px;
  color: #409eff;
}

.file-size {
  color: #909399;
  font-size: 12px;
}

.file-stats {
  display: flex;
  align-items: center;
  gap: 16px;
}

.file-word-count {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #67c23a;
  font-weight: 600;
}

.file-word-count i {
  font-size: 16px;
}

.file-points {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #e6a23c;
  font-weight: 600;
}

.file-points i {
  font-size: 16px;
}

.process-btn {
  flex-shrink: 0;
}

.file-result {
  margin-top: 24px;
}

.download-btn {
  background: #67c23a;
  border: none;
}

.download-btn:hover {
  background: #85ce61;
}

.file-upload-area >>> .el-upload-dragger {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.file-upload-area >>> .el-icon-upload {
  font-size: 67px;
  color: #c0c4cc;
  margin-bottom: 16px;
}

.file-upload-area >>> .el-upload__text {
  color: #606266;
  font-size: 14px;
}

.file-upload-area >>> .el-upload__text em {
  color: #2563eb;
  font-style: normal;
}

.file-upload-area >>> .el-upload__tip {
  font-size: 12px;
  color: #909399;
  margin-top: 7px;
}

.file-result {
  margin-top: 30px;
}

.download-btn {
  background: #10b981;
  border: none;
  padding: 10px 20px;
  height: 36px;
}

.download-btn:hover {
  background: #059669;
}

.download-btn >>> span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* 文本区域 */
.text-areas {
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* 移除固定高度，让内容自适应 */
}

/* 左右布局容器 */
.text-areas-horizontal {
  display: flex;
  gap: 20px;
  /* 移除固定高度，让内容自适应 */
}

.input-section,
.output-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0; /* 防止flex子元素溢出 */
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  flex-shrink: 0; /* 防止标题被压缩 */
}

.section-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.char-count {
  font-size: 13px;
  color: #9ca3af;
  white-space: nowrap;
}

/* 固定高度的文本框 */
.fixed-height-textarea {
  flex: 0 0 auto; /* 改为不伸缩 */
}

.fixed-height-textarea >>> .el-textarea__inner {
  height: 260px !important;
  min-height: 260px !important;
  max-height: 260px !important;
  resize: none !important;
}

/* 操作按钮区域 - 已废弃，改用左右按钮 */
.text-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px 0;
  border-top: 1px solid #e5e7eb;
}

/* 左侧按钮区域（原始文本下方） */
.left-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

/* 右侧按钮区域（优化结果下方） */
.right-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

/* 分割线 */
.text-divider {
  height: 1px;
  background: #e5e7eb;
}

.reduce-btn {
  background: #2563eb;
  border: none;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
}

.reduce-btn:hover {
  background: #1d4ed8;
}

.reduce-btn i {
  margin-right: 4px;
}

.reduce-btn-small:hover {
  background: #1d4ed8;
}

.reduce-btn-small >>> span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* 自定义主色调按钮（和一键生成相同的颜色） */
.custom-primary-btn {
  background: #2563eb !important;
  border: none !important;
  color: #fff !important;
}

.custom-primary-btn:hover {
  background: #1d4ed8 !important;
}

.custom-primary-btn:focus {
  background: #2563eb !important;
}

.custom-primary-btn:disabled {
  background: #93c5fd !important;
  opacity: 0.6;
}

.btn-icon-small {
  width: 16px;
  height: 16px;
}

.clear-btn {
  background: #f5f5f5;
  border: 1px solid #d9d9d9;
  color: #595959;
  padding: 12px 24px;
  font-size: 14px;
}

.clear-btn:hover {
  background: #e8e8e8;
  border-color: #bfbfbf;
}

.clear-btn i {
  margin-right: 4px;
}

.copy-btn {
  background: #2563eb;
  border: none;
  padding: 12px 24px;
  font-size: 14px;
}

.copy-btn:hover {
  background: #1d4ed8;
}

.copy-btn i {
  margin-right: 4px;
}

.compare-btn {
  background: #10b981;
  border: none;
  padding: 12px 24px;
  font-size: 14px;
}

.compare-btn:hover {
  background: #059669;
}

.compare-btn i {
  margin-right: 4px;
}

.compare-btn >>> span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.input-section >>> .el-textarea__inner,
.output-section >>> .el-textarea__inner {
  font-size: 14px;
  line-height: 1.8;
  border-color: #e5e7eb;
  resize: none;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.input-section >>> .el-textarea__inner:focus,
.output-section >>> .el-textarea__inner:focus {
  border-color: #4f46e5;
}

.output-section >>> .el-textarea__inner {
  background: #f9fafb;
}

/* 对比视图 */
.compare-view {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  margin-top: 20px;
}

.compare-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e5e7eb;
}

.compare-header h3 {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.close-compare-btn {
  color: #6b7280;
  padding: 4px 12px;
}

.close-compare-btn:hover {
  color: #374151;
}

.compare-content-wrapper {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  padding: 16px;
  max-height: 500px;
  overflow-y: auto;
}

.compare-text {
  font-size: 14px;
  line-height: 2;
  color: #1f2937;
  white-space: pre-wrap;
  word-break: break-word;
}

.compare-text >>> .text-deleted {
  color: #c00 !important;
  text-decoration: line-through !important;
}

.compare-text >>> .text-added {
  color: #080 !important;
}

@media (max-width: 768px) {
  .reduce-aigc-page {
    flex-direction: column;
  }

  .editor-panel {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
  }
}

/* 历史记录对话框样式 */
.history-dialog >>> .el-dialog__body {
  padding: 0;
}

.history-content {
  min-height: 400px;
  max-height: 600px;
}

.history-content >>> .el-tabs__header {
  margin: 0;
}

.history-content >>> .el-tabs__content {
  padding: 20px;
  max-height: 500px;
  overflow-y: auto;
}

.empty-history {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #909399;
}

.empty-history i {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-history p {
  font-size: 14px;
  margin: 0;
}

.history-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.history-item {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.2s;
}

.history-item:hover {
  border-color: #4f46e5;
  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.1);
}

.history-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f3f4f6;
}

.history-item-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.history-time {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}

.history-filename {
  font-size: 13px;
  color: #374151;
  font-weight: 600;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.history-words {
  font-size: 13px;
  color: #10b981;
  font-weight: 600;
}

.history-points {
  font-size: 13px;
  color: #f59e0b;
  font-weight: 600;
}

.history-item-actions {
  display: flex;
  gap: 8px;
}

.history-item-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.history-text-preview {
  display: flex;
  gap: 8px;
}

.preview-label {
  font-size: 13px;
  color: #6b7280;
  font-weight: 600;
  flex-shrink: 0;
  width: 70px;
}

.preview-text {
  font-size: 13px;
  color: #374151;
  line-height: 1.6;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.history-item-progress {
  display: flex;
  align-items: center;
  gap: 12px;
}

.progress-label {
  font-size: 13px;
  color: #6b7280;
  font-weight: 600;
  flex-shrink: 0;
}

.history-item-progress >>> .el-progress {
  flex: 1;
}

.history-file-stats {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f3f4f6;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #6b7280;
}

.stat-item i {
  font-size: 14px;
  color: #10b981;
}

.stat-warning {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #f59e0b;
  font-weight: 600;
  margin-left: auto;
}

.stat-warning i {
  font-size: 14px;
}

.history-pagination {
  display: flex;
  justify-content: center;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.history-pagination >>> .el-pagination {
  padding: 0;
}

.history-pagination >>> .el-pagination__total {
  font-size: 13px;
  color: #6b7280;
}

.history-pagination >>> .el-pager li {
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  font-size: 13px;
}

.history-pagination >>> .btn-prev,
.history-pagination >>> .btn-next {
  min-width: 28px;
  height: 28px;
  line-height: 28px;
}

.history-pagination >>> .el-pagination__jump {
  margin-left: 12px;
  font-size: 13px;
  color: #6b7280;
}

.history-pagination >>> .el-pagination__editor.el-input .el-input__inner {
  height: 28px;
  line-height: 28px;
  font-size: 13px;
}

/* 表格样式 */
.table-text-preview {
  font-size: 13px;
  color: #374151;
  line-height: 1.6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table-word-count {
  font-size: 14px;
  color: #10b981;
  font-weight: 600;
}

.table-points {
  font-size: 14px;
  color: #f59e0b;
  font-weight: 600;
}

/* 详情对话框样式 */
.detail-dialog >>> .el-dialog__body {
  padding: 0;
  max-height: 80vh;
  overflow-y: auto;
}

.detail-content {
  padding: 20px;
}

.detail-header {
  background: #f9fafb;
  padding: 16px 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #e5e7eb;
}

.detail-info-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.detail-info-row:last-child {
  margin-bottom: 0;
}

.detail-label {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
}

.detail-value {
  font-size: 14px;
  color: #374151;
  font-weight: 600;
  margin-left: 8px;
}

.detail-tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.detail-separate-view {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-text-section {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.detail-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}

.detail-section-header h4 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #374151;
}

.detail-text-content {
  padding: 16px;
  font-size: 14px;
  line-height: 1.8;
  color: #1f2937;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 400px;
  overflow-y: auto;
}

.detail-compare-view {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.compare-legend {
  display: flex;
  gap: 16px;
  align-items: center;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #6b7280;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: 2px solid;
}

.legend-color.deleted {
  border-color: #c00;
}

.legend-color.added {
  border-color: #080;
}

.detail-compare-content {
  padding: 16px;
  font-size: 14px;
  line-height: 2;
  color: #1f2937;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 500px;
  overflow-y: auto;
}

.detail-compare-content >>> .text-deleted {
  color: #c00 !important;
  text-decoration: line-through !important;
}

.detail-compare-content >>> .text-added {
  color: #080 !important;
}

/* 段落对比样式 */
.para-section.compare .para-label {
  background: #fef3c7;
  color: #92400e;
}

.compare-legend {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #6b7280;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: 1px solid #d1d5db;
}

.legend-color.deleted {
  background: #fee2e2;
  border-color: #fca5a5;
}

.legend-color.added {
  background: #d1fae5;
  border-color: #6ee7b7;
}

.compare-content {
  line-height: 1.8;
  white-space: pre-wrap;
  word-break: break-word;
}

/* 对比视图样式 - 文件上传处理 */
.compare-content >>> .text-deleted {
  color: #c00 !important;
  text-decoration: line-through !important;
  background: #fee2e2;
  padding: 2px 4px;
  border-radius: 3px;
}

.compare-content >>> .text-added {
  color: #080 !important;
  background: #d1fae5;
  padding: 2px 4px;
  border-radius: 3px;
}

.diff-removed {
  background: #fee2e2;
  color: #991b1b;
  text-decoration: line-through;
  padding: 2px 4px;
  border-radius: 3px;
}

.diff-added {
  background: #d1fae5;
  color: #065f46;
  padding: 2px 4px;
  border-radius: 3px;
}
</style>

<style>
.text-deleted {
  color: #c00 !important;
  text-decoration: line-through !important;
}

.text-added {
  color: #080 !important;
}
</style>
